import { Component, Input, OnInit, HostListener } from '@angular/core';
import * as M from 'mapbox-gl';
import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import {
	EVENT_EMITTERS,
	MAP_CONSTANTS,
	PRODUCT_NAMES,
	COUNTRY_MAP_COORDINATES
} from '../../../analytics/constants/analytics.constants';
import { MapComponentService, MapInterface, MapLegendItem } from '../map/map.component.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';
import { PATHS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-map-r10',
	templateUrl: './map-r10.component.html',
	styleUrls: ['./map-r10.component.css'],
	providers: [MapComponentService]
})
export class MapR10Component implements OnInit {
	/** Inputs */
	@Input() key: string;
	@Input() path: string;
	@Input() timeserieskey: string;
	@Input() tertiarykey: string;
	@Input() markericon: string;
	@Input() markericonhover: string;
	@Input() heatmapenabled: any;
	@Input() liftareacolor: string;
	@Input() showgeofencepoints: any;
	@Input() showgeocenters: any;
	@Input() showthirdpartyrtg: any;
	@Input() producttype: string;
	@Input() sectionclass: string;
	@Input() liftdistributionenabled: any = false;
	@Input() showgeofenceonoverview: any;
	//datatable variables
	@Input() columnsconfig: string;
	@Input() datatableconfig: string;
	@Input() uniqueoverwriteid: string;
	@Input() getdatafromwidget: string;
	public widgetIdProcesReq: string;

	protected dropdownIcons = { down: 'fa-angle-down', up: 'fa-angle-up' };
	public showTable: boolean = false;
	public tableIcon: string = 'fa-angle-down';
	public partnerCountryAbbr =
		this.analyticsDataModel.setupData.partner.countryDetails[0]['country_abbreviation'].toUpperCase();
	public partnerCountryLngLat = COUNTRY_MAP_COORDINATES[this.partnerCountryAbbr ? this.partnerCountryAbbr : 'USA'];
	public defaultMapZoom = 3.3;
	public mapCoordinates = {
		lng: 0,
		lat: 0
	};
	public doohData;
	public isDOOH: boolean = false;
	protected doohGeoRecencyData;
	protected DoohGeoFenceRecencyLayersDrawn = false;
	selectedItems: { [key: string]: boolean } = {};

	protected mapStyle = 'mapbox://styles/freq-e-deek/ckdhu86lm06ta1iqrobhlca25';
	protected miniMapStyle = 'mapbox://styles/freq-e-deek/ckdhu86lm06ta1iqrobhlca25';
	protected accessToken =
		'pk.eyJ1IjoiZnJlcS1lLWRlZWsiLCJhIjoiY2lmcHpidnJ6aHlxeHI3bHhvbzFtZTI4ZCJ9.BqXwR2aAH83EuuX0-ozozA';
	protected detailsTimeInterval: any;
	protected mapFillColor = this.colorUtilityService.getRGBByColorType(
		this.analyticsDataModel.partner.colorPalette,
		'primary',
		0.7
	);
	protected mapFillOutlineColor = this.colorUtilityService.getHEXByColorType(
		this.analyticsDataModel.partner.colorPalette,
		'primary',
		0.8
	);

	protected circleMarkerStyles = {
		'circle-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			0.7
		),
		'circle-radius': 7,
		'circle-stroke-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		),
		'circle-stroke-width': 1
	};

	protected circleMarkerStylesInvisible = {
		// to hide the dots on polygons. As that layer code is long back one and it might impact other places if we remove.
		'circle-color': 'transparent',
		'circle-radius': 7,
		'circle-stroke-color': 'transparent',
		'circle-stroke-width': 1
	};

	protected locationSelectionPaint = {
		'line-color': '#ffffff',
		'line-width': 3
	};

	protected geofenceSymbolType = 'circle';
	protected geofenceFillStyle = {
		'circle-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'secondary',
			1
		),
		'circle-radius': 3,
		'circle-stroke-color': '#fff',
		'circle-stroke-width': 1
	};

	protected geofenceBackgroundFillStyle = {
		'circle-color': 'rgba(0,0,0,0)',
		'circle-radius': 4,
		'circle-stroke-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'secondary',
			0.3
		),
		'circle-stroke-width': 4
	};

	protected retargetingFillStyle = {
		'circle-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'tertiary',
			1
		),
		'circle-radius': 3,
		'circle-stroke-color': '#fff',
		'circle-stroke-width': 1
	};

	protected retargetingbackgroundFillStyle = {
		'circle-color': 'rgba(0,0,0,0)',
		'circle-radius': 4,
		'circle-stroke-color': this.colorUtilityService.getRGBByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'tertiary',
			0.3
		),
		'circle-stroke-width': 4
	};

	public showPolygonLayerDetailsFlag = false;
	public showGeofenceCenterDetailsFlag = false;
	public polygonLayerDetails: any = {};
	public geofenceCenterDetails: any;
	public noRegionData = false;
	public detailMapPoints: any;
	public showLoad = true;
	public histogramData = {};
	public showGeofenceLegends: boolean = false;
	public noData = true;
	public map: any;
	public minimap: any;
	public showLocationName: boolean = false;

	protected sourceLayerDetails: any;
	protected mapType = 'overview';

	protected selectedCombination: any;
	protected displayGeoFenceData: any;
	protected displayGeoRecencyData: any;
	protected prerollGeoFenceData: any;
	protected prerollGeoRecencyData: any;
	protected heatmapOpacities = {};
	protected geoFenceMarkersDrawn = false;
	protected geoVideoMarkersDrawn = false;
	protected geoFenceRecencyLayersDrawn = false;
	protected geoVideoRecencyLayersDrawn = false;
	protected geoFenceMarkers = [];
	protected geoVideoMarkers = [];
	public hasOnlyGeoFenceSelected: boolean = false;
	public mapObj: MapInterface;
	public legendItems: MapLegendItem[] = [];
	public hasHouseholdDetails: boolean = false;
	public legendsChunk: any = [];

	protected vectorMap: any = {};
	protected mapboxMapId: any = this.analyticsDataModel.setupData.partner.mapboxId;
	protected intervalFn: any;
	protected showingLiftRegionsOnMap = false;

	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 1
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 3
		},
		{
			productName: 'CTV/OTT',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasCtv'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasRadio'],
			order: 6
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasSem'],
			order: 7
		}
	];

	protected GF_PRODUCTS: any = [
		{
			productName: 'GeoFence',
			productKey: MAP_CONSTANTS.STATE.GEOFENCE,
			isDisabled: false,
			isDependent: true,
			isSelected: false,
			showLiftHover: false,
			hasGeoFence: true,
			showInLegend: true,
			flag: ['hasGeoFence'],
			order: 1
		},
		{
			productName: 'GeoVideo',
			productKey: 'geovideo',
			isDisabled: false,
			isDependent: true,
			isSelected: false,
			showLiftHover: false,
			hasGeoFence: true,
			showInLegend: true,
			flag: ['hasGeoVideo'],
			order: 2
		}
	];

	public reloadSubscription;
	public mapDataSubscription;
	public mapBoundsSubscription;
	public geofenceSelectedItem;
	public navItemsStatus = {
		geovideo: false,
		geofence: false
	};
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_STATUS).subscribe((res) => {
			if (Object.keys(this.navItemsStatus).includes(res.path)) {
				this.navItemsStatus[res.path] = res.isDisabled;
				this.updateGeofenceLegendItems();
				this.setOnlyGeofenceSelected();
				this.setlegendsChunk();
				this.updateSelectedRegionsOnProductSelection();
				this.drawMap();
			}
		});
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
			this.noRegionData = false;
		});
	}

	@HostListener('window:resize', ['$event'])
	winsowOnResize(event: any): void {
		this.onResize({});
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of a directive are
	 * initialized.
	 */
	ngOnInit() {
		this.mapComponentService.defaultProducts = this.DEFAULT_PRODUCTS;
		this.mapComponentService.geofenceProducts = this.GF_PRODUCTS;
		this.isDOOH = this.analyticsDataModel.getCurrentPath() === PATHS.DOOH;
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 23;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 1;
	}

	/**
	 * Lifecycle hook that is called after a component's view has been fully
	 * initialized.
	 */
	ngAfterViewInit() {
		this.mapboxMapId.forEach((vectorId) => {
			this.vectorMap[vectorId] = {
				source_layers: {
					points: { properties: ['gcd_id', 'local_id'] },
					polygons: { properties: ['gcd_id', 'local_id'] }
				}
			};
		});
		Object.getOwnPropertyDescriptor(M, 'accessToken').set(this.accessToken);
		this.heatmapenabled = this.heatmapenabled === 'true';
		this.showgeocenters = this.showgeocenters === 'true' ? true : false;
		this.showthirdpartyrtg = this.showthirdpartyrtg == 'undefined' || this.showthirdpartyrtg === 'true' ? true : false;
		this.showgeofencepoints = this.showgeofencepoints === 'true' ? true : false;
		this.showgeofenceonoverview = this.showgeofenceonoverview === 'true' ? true : false;
		// Getting backend data
		this.initializeMap();
		this.requestData();
	}

	/**
	 * Lifecycle hook that is called when a directive, pipe or service is destroyed.
	 */
	ngOnDestroy() {
		this.destroyMap();
		this.vectorMap = {};
		this.polygonLayerDetails = {};
		this.heatmapOpacities = {};
		this.geoFenceMarkers = [];
		this.geoVideoMarkers = [];
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.mapDataSubscription) {
			this.mapDataSubscription.unsubscribe();
		}
		if (this.mapBoundsSubscription) {
			this.mapBoundsSubscription.unsubscribe();
		}
	}

	/**
	 *
	 */
	protected initializeMap() {
		this.map = new M.Map({
			container: 'map', // container id
			style: this.mapStyle, // stylesheet location
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: this.defaultMapZoom // starting zoom
		});
		this.map.scrollZoom.disable();
		this.map.on('load', () => {
			this.onResize({});
			this.map.on('mousemove', 'geofence-markers', (e) => {
				this.showGeofenceCenterDetails(e.features[0].properties, this.displayGeoFenceData);
				this.showGeofenceCenterDetails(e.features[0].properties, this.prerollGeoFenceData);
			});

			this.map.on('mouseleave', 'geofence-markers', () => {
				this.hideGeofenceCenterDetails();
			});

			this.map.on('zoomend', () => {
				this.zoomChanged();
			});
		});
		this.minimap = new M.Map({
			container: 'minimap', // container id
			style: this.miniMapStyle, // stylesheet location
			center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
			zoom: this.defaultMapZoom // starting zoom
		});
	}

	/**
	 *
	 */
	protected destroyMap() {
		if (this.map) {
			this.map.remove();
		}
		if (this.minimap) {
			this.minimap.remove();
		}
	}

	/**
	 * get data from backend and process data
	 * @param product - selected state
	 */
	requestData() {
		this.showLoad = true;
		this.noData = false;
		this.mapComponentService.showThirdPartyRTG = this.showthirdpartyrtg;
		this.mapComponentService.setSelectedStateByPath(this.path);
		const selectedState = this.mapComponentService.selectedState;
		//resize to actual width
		this.onResize({});
		if (this.mapDataSubscription) {
			this.mapDataSubscription.unsubscribe();
		}
		//next line:  to get the overview map data to use if there is no changes in adv/camp/dates changes and overview page already loaded
		this.widgetIdProcesReq = !this.isDOOH
			? !this.widgetIdProcesReq && this.getdatafromwidget && this.getdatafromwidget != 'undefined'
				? !this.AnalyticsDataChachingService.checkSelectionsChanges(this.getdatafromwidget)
					? this.AnalyticsDataChachingService.ANALYTICS_WIDGETS_CACHED_DATA.data[this.getdatafromwidget]?.['response']
						? this.getdatafromwidget
						: this.uniqueoverwriteid
					: this.uniqueoverwriteid
				: this.uniqueoverwriteid
			: null;
		this.mapDataSubscription = this.analyticsService
			.getMapWidgetData(this.key, selectedState, this.producttype, this.widgetIdProcesReq)
			.subscribe((res: any) => {
				if (res.success && Object.keys(res.data).length) {
					//next condition:  to get the overview map data to use if there is no changes in adv/camp/dates changes and overview page already loaded
					if (this.widgetIdProcesReq !== this.uniqueoverwriteid) {
						let reqData = {};
						if (!res.data[selectedState]) {
							res.data[selectedState] = {
								geofence_multipoints: '',
								hide_show_geofence_on_zoom_level: '0',
								zr_regions: []
							};
						}
						res.data[selectedState]['zr_regions'] = res.data['all']?.['zr_regions'];
						reqData[selectedState] = res.data[selectedState];
						res.data = reqData;
					}

					// showgeofenceonoverview - will enable/disable geofence/geovideo points on overview
					let processObj = { data: res.data, condition: this.showgeofenceonoverview };
					// Process backend data
					this.mapComponentService.mapData = processObj;
					this.mapObj = this.mapComponentService.generateMapRequiredData(this.analyticsDataModel.setupData.permissions);
					this.legendItems = this.mapObj.legend;
					this.displayGeoFenceData = this.mapComponentService.displayGeofenceObj;
					this.displayGeoRecencyData = this.mapComponentService.displayGeorecencyObj;
					this.prerollGeoFenceData = this.mapComponentService.prerollGeofenceObj;
					this.prerollGeoRecencyData = this.mapComponentService.prerollGeorecencyObj;
					this.doohData = this.mapComponentService.doohGeorecencyObj;
					this.doohGeoRecencyData = JSON.parse(JSON.stringify(this.doohData));
					// Object to track selected DOOH checkboxes (keyed by id)
					this.selectedItems = this.doohData.features.reduce((acc, feature) => {
						acc[feature.properties.id] = true; // All checkboxes are selected initially
						return acc;
					}, {});

					this.showGeofenceLegends = this.hasGeoFenceData() || this.producttype == 'geofence_only' ? true : false;
					this.liftdistributionenabled = !(this.producttype == 'geofence_only');
					this.setLiftProductsStatus();
					this.updateGeofenceLegendItems();
					this.setOnlyGeofenceSelected();
					this.setlegendsChunk();
					EmitterService.get(EVENT_EMITTERS.INITIATE_MAP_STATS).emit(this.mapObj);

					if (this.mapObj && this.mapObj.combinations.length > 0) {
						//product selection -- todo refactor
						this.updateSelectedRegionsOnProductSelection();
						this.getBoundsForAllFilters();
						setTimeout(() => {
							const intervalFn = setInterval(() => {
								if (this.checkFilterObjStatus()) {
									clearInterval(intervalFn);
									this.drawMap();
								}
							}, 200);
						}, 50);
					} else if (
						(this.hasGeoFenceData() || this.doohGeoRecencyData.features.length > 0) &&
						this.mapObj.combinations.length === 0
					) {
						this.selectedCombination = undefined;
						setTimeout(() => {
							this.drawMap();
							const mapBounds = this.boundsForAvailableGeoFenceProducts;
							const zoomRange = this.get_bounds_zoom(mapBounds);
							this.map.fitBounds(mapBounds, {
								padding: this.isDOOH ? undefined : { top: 100, bottom: 300, left: 400, right: 20 },
								linear: true,
								maxZoom: zoomRange
							});
						}, 500);
					} else {
						this.selectedCombination = {};
						this.refreshMap();
						this.clearMap();
						this.showLoad = false;
					}
					this.noData = false;
				} else {
					this.selectedCombination = {};
					this.refreshMap();
					this.clearMap();
					this.noData = true;
				}
				this.showLoad = false;
			});
	}

	hasGeoFenceData() {
		return (
			(this.displayGeoFenceData && this.displayGeoFenceData.features && this.displayGeoFenceData.features.length > 0) ||
			(this.prerollGeoFenceData && this.prerollGeoFenceData.features && this.prerollGeoFenceData.features.length > 0)
		);
	}

	setLiftProductsStatus() {
		this.hasHouseholdDetails = ![MAP_CONSTANTS.STATE.SEM, MAP_CONSTANTS.STATE.CTV].includes(
			this.mapComponentService.selectedState
		);
	}

	clearMap() {
		this.removeAllGeoFenceMarkers();
		this.removeAllGeoRecencyLayers();
		this.removeDOOHGeoRecencyLayer();
		this.drawCenter();
	}
	protected removeDOOHGeoRecencyLayer() {
		if (this.DoohGeoFenceRecencyLayersDrawn) {
			this.removeMapLayer('dooh_geofence_points_georecency');
		}
	}
	protected processLegendSelection() {
		if (this.analyticsDataModel.getCurrentPath() == 'overview') {
			for (let i = 0; i < 2; i++) {
				const gfProduct =
					i == 0
						? _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE })
						: _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
				this.setOnlyGeofenceSelected(gfProduct);
				if (gfProduct) {
					if (this.hasOnlyGeoFenceSelected) {
						this.noRegionData = false;
					} else {
						this.noRegionData = true;
					}
					this.toggleGeoFenceData(
						this.geofenceSelectedItem[0] ? this.geofenceSelectedItem[0].isSelected : false,
						gfProduct
					);
				}
			}
		} else {
			let gfProduct: any = {};
			if (this.analyticsDataModel.getCurrentPath() == 'display') {
				gfProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE });
			} else if (this.analyticsDataModel.getCurrentPath() == 'preroll') {
				gfProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOVIDEO });
			}
			this.setOnlyGeofenceSelected(gfProduct);
			if (gfProduct) {
				if (this.hasOnlyGeoFenceSelected) {
					this.noRegionData = false;
				} else {
					this.noRegionData = true;
				}
				this.toggleGeoFenceData(
					this.geofenceSelectedItem[0] ? this.geofenceSelectedItem[0].isSelected : false,
					gfProduct
				);
			}
		}
	}

	protected setOnlyGeofenceSelected(gfProduct?) {
		let selectedItems = _.where(this.legendItems, { isSelected: true, isDependent: false });
		this.geofenceSelectedItem = _.where(this.legendItems, { isSelected: true, hasGeoFence: true }).filter(
			(item) => !gfProduct || item.productKey == gfProduct?.productKey
		);
		this.hasOnlyGeoFenceSelected = selectedItems.length == 0 && this.geofenceSelectedItem.length > 0;
	}

	/**
	 * Change map layers based on selected legend item
	 * @param {MapLegendItem} legendItem
	 */
	public selectedProductDetails(legendItem: MapLegendItem) {
		legendItem.isSelected = !legendItem.isSelected;
		this.processLegendSelection();
		this.updateSelectedRegionsOnProductSelection();
		this.refreshMap();
		this.drawCenter();
	}

	/**
	 * function to update geofence/geovideo legend items
	 */
	protected updateGeofenceLegendItems() {
		if (this.legendItems.length > 0) {
			for (const legend of this.legendItems) {
				if (legend.productKey === MAP_CONSTANTS.STATE.GEOFENCE) {
					let enableGeofenceProductLegend =
						this.displayGeoFenceData &&
						this.displayGeoFenceData.features &&
						this.displayGeoFenceData.features.length > 0 &&
						!this.navItemsStatus.geofence;
					legend.isDisabled = !enableGeofenceProductLegend;
					legend.isSelected = !legend.isDisabled;
				} else if (legend.productKey === MAP_CONSTANTS.STATE.GEOVIDEO) {
					let enableGeovideoProductLegend =
						this.prerollGeoFenceData &&
						this.prerollGeoFenceData.features &&
						this.prerollGeoFenceData.features.length > 0 &&
						!this.navItemsStatus.geovideo;
					legend.isDisabled = !enableGeovideoProductLegend;
					legend.isSelected = !legend.isDisabled;
				}
			}
		}
	}

	/**
	 *
	 * @param {LatLngBounds} comparisonBounds, bounds to check
	 * @return {float} zoom
	 */
	protected get_bounds_zoom(comparisonBounds) {
		const current_bounds = this.map.getBounds();
		const current_zoom = this.map.getZoom();
		if (!_.isEmpty(comparisonBounds)) {
			const best_fit = Math.min(
				Math.log2(
					(current_bounds.getNorth() - current_bounds.getSouth()) /
						(comparisonBounds.getNorth() - comparisonBounds.getSouth())
				),
				Math.log2(
					(current_bounds.getEast() - current_bounds.getWest()) /
						(comparisonBounds.getEast() - comparisonBounds.getWest())
				)
			);
			return best_fit + current_zoom - 0.5; // Until bounds with pitch/tilt can be calculated correctly
		}
		return current_zoom - 0.5;
	}

	/**
	 *
	 * @param filterObj
	 */
	protected getBoundsByZCTAIds(filterObj) {
		this.mapBoundsSubscription = this.analyticsService
			.getBoundsByZCTA(filterObj.localIds)
			.subscribe((response: any) => {
				if (!filterObj.status && response.success) {
					this.calculateZoomForFilterObj(filterObj, response.bounds);
				}
			});
	}

	/**
	 *
	 * @param filterObj
	 * @param boundValues
	 */
	protected calculateZoomForFilterObj(filterObj, boundValues) {
		const minLng = !UtilityService.isUndefinedOrNull(boundValues[0][0]) ? parseFloat(boundValues[0][0]) : 0;
		const minLat = !UtilityService.isUndefinedOrNull(boundValues[0][1]) ? parseFloat(boundValues[0][1]) : 0;
		const maxLat = !UtilityService.isUndefinedOrNull(boundValues[1][1]) ? parseFloat(boundValues[1][1]) : 0;
		const maxLng = !UtilityService.isUndefinedOrNull(boundValues[1][0]) ? parseFloat(boundValues[1][0]) : 0;
		const bounds: any = [
			[minLng, minLat],
			[maxLng, maxLat]
		];
		const comparisonBounds = M.LngLatBounds.convert(bounds);
		const zoomRange = this.get_bounds_zoom(comparisonBounds);
		filterObj.zoomRange = zoomRange;
		filterObj.center = comparisonBounds.getCenter();
		filterObj.status = !filterObj.stack;
	}

	protected getBoundsForAllFilters() {
		const combinations = this.mapObj.combinations;
		for (const combination of combinations) {
			this.getBoundsByZCTAIds(combination);
		}
	}

	/**
	 *
	 * @returns boolean
	 */
	protected checkFilterObjStatus() {
		const statusArray = _.pluck(this.mapObj.combinations, 'status');
		return _.indexOf(statusArray, false) === -1;
	}

	/**
	 *
	 */
	protected checkFiltersStatus() {
		if (this.checkFilterObjStatus()) {
			clearInterval(this.intervalFn);
			this.drawMap();
		}
	}

	/**
	 *
	 */
	protected drawMap() {
		this.showLoad = true;
		this.processResponseData();
		if (!_.isEmpty(this.displayGeoFenceData) || !_.isEmpty(this.prerollGeoFenceData)) {
			if (!this.navItemsStatus.geofence || !this.navItemsStatus.geovideo) {
				this.drawAllGeoFencePoints();
				this.drawAllGeoRecencyLayer();
				this.drawDOOHGeoRecencyLayer();
			}
		} else {
			this.removeAllGeoRecencyLayers();
			this.removeAllGeoFenceMarkers();
			this.removeDOOHGeoRecencyLayer();
		}
		this.showLoad = false;
		this.onResize({});
	}
	/**
	 *
	 */
	protected updateSelectedRegionsOnProductSelection() {
		const nonDependentItems = _.where(this.legendItems, { isDependent: false });
		const selectedLegendItems = _.where(nonDependentItems, { isSelected: true });
		const productKeys = _.pluck(selectedLegendItems, 'productKey');
		const combinationKey = this.getCombinationKeyByProductKeys(productKeys);
		const combinationObj: any = _.findWhere(this.mapObj.combinations, { key: combinationKey });
		this.selectedCombination = combinationObj;
	}

	/**
	 *
	 * @param {string[]} productKeys
	 * @returns {string}
	 */
	protected getCombinationKeyByProductKeys(productKeys: string[]) {
		return productKeys.join('_');
	}

	/**
	 *
	 */
	processResponseData() {
		for (const vectorMapId in this.vectorMap) {
			this.removeMapLayer('overview_active_' + vectorMapId + '_points');
			this.removeMapLayer('overview_inactive_' + vectorMapId + '_points');
			this.removeMapLayer('overview_main_' + vectorMapId + '_polygons');
			this.removeMapLayer('overview_hover_' + vectorMapId + '_polygons');
			this.removeMapLayer('overview_selection_' + vectorMapId + '_polygons');
			this.removeMapSource('overview_geography_source_' + vectorMapId);
			this.map.addSource('overview_geography_source_' + vectorMapId, {
				type: 'vector',
				url: 'mapbox://' + vectorMapId
			});

			this.sourceLayerDetails = this.vectorMap[vectorMapId].source_layers;
			this.drawLayersOnMap(vectorMapId);
		}
		this.drawCenter();
	}

	/**
	 *
	 */
	protected drawCenter() {
		if (this.selectedCombination && this.selectedCombination.center) {
			this.map.easeTo({
				center: this.selectedCombination.center,
				zoom: this.selectedCombination.zoomRange,
				duration: 0
			});
		} else if (this.hasOnlyGeoFenceSelected || this.doohGeoRecencyData?.features.length > 0) {
			const mapBounds = this.boundsForAvailableGeoFenceProducts;
			const zoomRange = this.get_bounds_zoom(mapBounds);
			if (!_.isEmpty(mapBounds)) {
				this.map.fitBounds(mapBounds, {
					padding: 10,
					linear: true,
					maxZoom: zoomRange
				});
			}
		} else {
			this.map.easeTo({
				center: [this.mapCoordinates['lng'], this.mapCoordinates['lat']], // starting position [lng, lat]
				zoom: this.defaultMapZoom, // starting zoom
				duration: 0
			});
		}
	}

	/**
	 *
	 * @param {string} vectorMapId
	 */
	protected drawLayersOnMap(vectorMapId: string) {
		for (const geoMapSourceLayer in this.sourceLayerDetails) {
			const filter = [];
			const geoFilter = [];
			const propertyToFilter = this.sourceLayerDetails[geoMapSourceLayer].properties[0];
			const geos = _.map(
				_.pluck(this.selectedCombination ? this.selectedCombination.regionData : [], propertyToFilter),
				(value) => {
					return parseInt(value);
				}
			);
			Array.prototype.push.apply(filter, ['in', propertyToFilter].concat(geos));
			geoFilter.push(filter);
			let layerOpacity = ['match', ['get', 'gcd_id'], 0, 1, 1];
			if (this.heatmapenabled && this.selectedCombination) {
				layerOpacity = this.selectedCombination.opacity;
			}
			this.drawRegionsLayer(geoMapSourceLayer, vectorMapId, geoFilter, propertyToFilter, layerOpacity);
		}
	}

	/**
	 *
	 * @param {string} mapSourceLayer
	 * @param {string} vectorMapId
	 * @param filter
	 * @param propertyToFilter
	 * @param opacity
	 */
	protected drawRegionsLayer(
		mapSourceLayer: string,
		vectorMapId: string,
		filter: any,
		propertyToFilter: any,
		opacity?: any
	) {
		if (mapSourceLayer === 'polygons') {
			this.removeMapLayer(this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': opacity
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': 1
				},
				filter: ['==', propertyToFilter, '']
			});

			let geo_hover_timeout;
			this.map.on('mousemove', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const gcdId =
						e && e.features && e.features[0].properties['gcd_id'] ? e.features[0].properties['gcd_id'].toString() : '';
					let regionObject = gcdId ? _.findWhere(this.selectedCombination.regionData, { gcd_id: gcdId }) : {};
					this.displayLocationDataOnMouseover(regionObject, e);
				}
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							e && e.feature && e.feature[0] && e.features[0].properties
								? e.features[0].properties[propertyToFilter]
								: ''
						]);
					}
				}, 10);
			});

			this.map.on('mouseleave', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, () => {
				this.hideLocationDataOnMouseout();
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							''
						]);
					}
				}, 10);
			});

			//adding layer with visibility as none to show it only on location selection
			this.removeMapLayer(this.mapType + '_selection_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_selection_' + vectorMapId + '_' + mapSourceLayer,
				type: 'line',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.locationSelectionPaint,
				layout: {
					visibility: 'none'
				},
				filter: filter[filter.length - 1]
			});
		} else if (mapSourceLayer === 'points') {
			this.removeMapLayer(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStylesInvisible,
				filter: filter[filter.length - 1]
			});
			this.map.setLayerZoomRange(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.removeMapLayer(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStyles,
				filter: ['==', propertyToFilter, '']
			});
			this.map.setLayerZoomRange(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.map.on('mousemove', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mousemove', this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mouseleave', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				this.hideLocationDataOnMouseout();
			});
		}
	}

	protected showLift(regionObj: any) {
		let showLiftFlag = false;
		if (regionObj) {
			const showLift = [];

			if (regionObj.sem && parseInt(regionObj.sem)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.SEM });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.ctv && parseInt(regionObj.ctv)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.CTV });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.display && parseInt(regionObj.display)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.DISPLAY });
				showLift.push(product.showLiftHover);
			}

			if (regionObj.preroll && parseInt(regionObj.preroll)) {
				const product = _.findWhere(this.DEFAULT_PRODUCTS, { productKey: MAP_CONSTANTS.STATE.PREROLL });
				showLift.push(product.showLiftHover);
			}

			const showLiftFlag = _.reduce(
				showLift,
				(val, bool) => {
					return val || bool;
				},
				false
			);

			return showLiftFlag;
		}
		return showLiftFlag;
	}

	/**
	 *
	 * @param regionObj
	 */
	protected displayLocationDataOnMouseover(regionObj, e) {
		if (!_.isEmpty(regionObj)) {
			this.polygonLayerDetails = {
				regionName: regionObj.city,
				region: regionObj.region,
				zip: regionObj.local_id,
				isTV: !!parseInt(regionObj.tv),
				isSem: !!parseInt(regionObj.sem),
				population: parseInt(regionObj.population).toLocaleString('en-US'),
				zone: regionObj.zone
			};

			// this.polygonLayerDetails['showLift'] = this.showLift(regionObj);
			this.polygonLayerDetails['preroll'] = regionObj.lift['preroll'];
			this.polygonLayerDetails['display'] = regionObj.lift['display'];
			this.polygonLayerDetails['ctv'] = regionObj.lift['ctv'];
			const key = this.selectedCombination?.key;
			this.polygonLayerDetails['showLift'] = key?.includes('_') || this.polygonLayerDetails[key] == true;
			const nonDependentItems = _.where(this.legendItems, { isDependent: false });
			const selectedLegendItems = _.where(nonDependentItems, { isSelected: true });
			const productKeys = _.pluck(selectedLegendItems, 'productKey');
			const combinationKey = this.getCombinationKeyByProductKeys(productKeys);
			const combinationObj: any = _.findWhere(this.mapObj.combinations, { key: combinationKey });
			this.selectedCombination = combinationObj;
			if (regionObj.lift && this.polygonLayerDetails['showLift']) {
				if (combinationKey.indexOf('display') != -1 || combinationKey.indexOf('preroll') != -1) {
					const avgLift = parseFloat(regionObj.lift.average_lift);
					this.polygonLayerDetails['avgLift'] =
						avgLift > 0 ? (avgLift > 99 ? '> 99' : regionObj.lift.average_lift) : '';
				} else {
					this.polygonLayerDetails['showLift'] = false;
				}
				this.polygonLayerDetails['avgHomeValue'] = regionObj.lift.avg_home_value;
				this.polygonLayerDetails['avgMedianAge'] = regionObj.lift.avg_median_age;
				this.polygonLayerDetails['avgIncome'] = regionObj.lift.avg_income;
			}
			this.showPolygonLayerDetailsFlag = true;
		}
	}

	protected hideLocationDataOnMouseout() {
		this.showPolygonLayerDetailsFlag = false;
		this.polygonLayerDetails = {};
	}

	protected drawAllGeoFencePoints(product?) {
		this.removeAllGeoFenceMarkers(product);
		if (this.displayGeoFenceData && (!product || product.productKey === MAP_CONSTANTS.STATE.GEOFENCE)) {
			this.geoFenceMarkersDrawn = true;
			this.geoFenceMarkers = [];
			this.drawGeoFencePoints(this.displayGeoFenceData, '_geofence', PRODUCT_NAMES.GEOFENCE);
		}
		if (this.prerollGeoFenceData && (!product || product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO)) {
			this.geoVideoMarkersDrawn = true;
			this.geoVideoMarkers = [];
			this.drawGeoFencePoints(this.prerollGeoFenceData, '_geovideo', PRODUCT_NAMES.GEOVIDEO);
		}
	}

	/**
	 * function to add geofence points and markers on the map (geofence/geovideo)
	 *
	 * @param geofencedata
	 * @param layerId
	 * @param productName
	 */
	protected drawGeoFencePoints(geofencedata: any, layerId?: string, productName?: string) {
		geofencedata.features.forEach((marker: any) => {
			// create a DOM element for the marker
			const el = document.createElement('div');
			el.className = 'marker';
			el.style.backgroundImage = 'url(' + this.markericon + ')';
			el.style.backgroundPosition = 'center';
			el.style.backgroundSize = 'cover';
			el.style.width = 45 + 'px';
			el.style.height = 45 + 'px';
			el.addEventListener('mouseover', (event: any) => {
				this.showGeofenceCenterDetails(marker.properties, geofencedata);
				if (this.markericonhover) {
					event.currentTarget.style.backgroundImage = 'url(' + this.markericonhover + ')';
				}
			});

			el.addEventListener('mouseleave', (event: any) => {
				this.hideGeofenceCenterDetails();
				event.currentTarget.style.backgroundImage = 'url(' + this.markericon + ')';
			});

			// add marker to map
			const gfMarker = new M.Marker(el)
				.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
				.addTo(this.map);
			if (PRODUCT_NAMES.GEOFENCE === productName) {
				this.geoFenceMarkers.push(gfMarker);
			} else if (PRODUCT_NAMES.GEOVIDEO === productName) {
				this.geoVideoMarkers.push(gfMarker);
			}
		});
	}

	/**
	 * function to add georecency layer to map (geofence/geovideo)
	 */
	protected drawAllGeoRecencyLayer(product?) {
		if (this.displayGeoRecencyData && (!product || product.productKey === MAP_CONSTANTS.STATE.GEOFENCE)) {
			this.geoFenceRecencyLayersDrawn = true;
			this.drawGeoRecencyLayer(this.displayGeoRecencyData, '_display_georecency');
		}
		if (this.prerollGeoRecencyData && (!product || product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO)) {
			this.geoVideoRecencyLayersDrawn = true;
			this.drawGeoRecencyLayer(this.prerollGeoRecencyData, '_preroll_georecency');
		}
	}

	protected drawGeoRecencyLayer(georecencyData: any, layerId?: string) {
		this.removeMapLayer('geofence_points' + layerId);
		this.removeMapLayer('geofence_points' + layerId + '_2');
		this.removeMapSource('geofence_points' + layerId);
		this.removeMapSource('geofence_points' + layerId + '_2');
		if (this.map && !this.map.getLayer('geofence_points' + layerId)) {
			if (georecencyData.features.length > 0) {
				this.map.addLayer({
					id: 'geofence_points' + layerId,
					type: 'circle',
					source: {
						type: 'geojson',
						data: georecencyData
					},
					paint: this.retargetingFillStyle
				});
				//background blur of goefence
				if (this.retargetingbackgroundFillStyle && !this.map.getLayer('geofence_points' + layerId + '_2')) {
					this.map.addLayer({
						id: 'geofence_points' + layerId + '_2',
						type: 'circle',
						source: {
							type: 'geojson',
							data: georecencyData
						},
						paint: this.retargetingbackgroundFillStyle
					});
				}
			}
		}
	}

	/**
	 *
	 * @param id
	 */
	protected removeMapLayer(id) {
		if (this.map && typeof this.map.getLayer === 'function' && this.map.getLayer(id)) {
			this.map.removeLayer(id);
		}
	}

	/**
	 *
	 * @param id
	 */
	protected removeMapSource(id) {
		if (this.map && typeof this.map.getSource === 'function' && this.map.getSource(id)) {
			this.map.removeSource(id);
		}
	}

	/**
	 * Remove all the geofence marker
	 */
	protected removeAllGeoFenceMarkers(product?) {
		if (this.geoFenceMarkersDrawn && (!product || product.productKey === MAP_CONSTANTS.STATE.GEOFENCE)) {
			this.geoFenceMarkersDrawn = false;
			for (const marker of this.geoFenceMarkers) {
				marker.remove();
			}
		}

		if (this.geoVideoMarkersDrawn && (!product || product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO)) {
			this.geoVideoMarkersDrawn = false;
			for (const marker of this.geoVideoMarkers) {
				marker.remove();
			}
		}
	}

	/**
	 * remove all the georecency/retargeting removeAllGeoRecencyLayerslayers
	 */
	protected removeAllGeoRecencyLayers(product?) {
		if (this.map) {
			if (
				this.displayGeoFenceData &&
				this.geoFenceRecencyLayersDrawn &&
				(!product || product.productKey === MAP_CONSTANTS.STATE.GEOFENCE)
			) {
				this.removeMapLayer('geofence_points_display_georecency');
				this.removeMapLayer('geofence_points_display_georecency_2');
			}
			if (
				this.prerollGeoRecencyData &&
				this.geoVideoRecencyLayersDrawn &&
				(!product || product.productKey === MAP_CONSTANTS.STATE.GEOVIDEO)
			) {
				this.removeMapLayer('geofence_points_preroll_georecency');
				this.removeMapLayer('geofence_points_preroll_georecency_2');
			}
		}
	}

	/**
	 * manage polygon center layer and polygon layer based on zoom level
	 */
	protected zoomChanged() {
		if (this.map.getZoom() > 6) {
			if (this.map && this.map.getLayer('polygons')) {
				this.map.setLayoutProperty('polygons', 'visibility', 'visible');
			}
			if (this.map && this.map.getLayer('polygon-centers')) {
				this.map.setLayoutProperty('polygon-centers', 'visibility', 'none');
			}
		} else {
			if (this.map && this.map.getLayer('polygon-centers')) {
				this.map.setLayoutProperty('polygon-centers', 'visibility', 'visible');
			}
			if (this.map && this.map.getLayer('polygons')) {
				this.map.setLayoutProperty('polygons', 'visibility', 'none');
			}
		}
	}

	/**
	 * toggle geofence and manage geofence layer
	 * @param flag - toggle value of geofence
	 */
	protected toggleGeoFenceData(flag, product?) {
		if (!flag) {
			this.removeAllGeoFenceMarkers(product);
			this.removeAllGeoRecencyLayers(product);
		} else {
			this.drawAllGeoFencePoints(product);
			this.drawAllGeoRecencyLayer(product);
			this.drawDOOHGeoRecencyLayer();
		}
	}

	/**
	 * Set map zoom level and lat, lon values based on layer data
	 */
	protected setMapBounds(map, boundsData, isApplyPadding) {
		let coordinates = [];
		map.resize();
		if (boundsData.features) {
			_.each(boundsData.features, (point: any) => {
				coordinates.push(point.geometry.coordinates);
			});
		} else {
			coordinates = boundsData.geometry.coordinates;
		}
		const boundedData = coordinates.reduce(function (bounds, coord) {
			return bounds.extend(coord);
		}, new M.LngLatBounds(coordinates[0], coordinates[0]));
		if (isApplyPadding) {
			map.fitBounds(boundedData, {
				padding: {
					top: 100,
					bottom: 10,
					left: 200,
					right: 10
				}
			});
		} else {
			map.fitBounds(boundedData, {
				padding: 10
			});
		}
	}

	/**
	 * map zoom in function
	 */
	public zoomIn() {
		this.map.setZoom(this.map.getZoom() + 1);
	}

	/**
	 * map zoom out function
	 */
	public zoomOut() {
		if (this.selectedCombination && this.selectedCombination.zoomRange) {
			this.selectedCombination.zoomRange = this.map.getZoom() - 1;
		}
		this.map.setZoom(this.map.getZoom() - 1);
	}

	/**
	 * Show geofence center data on hover
	 * @param geofenceCenterPoint - geofence center object
	 */
	protected showGeofenceCenterDetails(geofenceCenterPoint: any, geofenceData: any) {
		clearTimeout(this.detailsTimeInterval);
		this.showPolygonLayerDetailsFlag = false;
		this.showGeofenceCenterDetailsFlag = true;
		jQuery('.geofence-details-container').css('display', 'block');
		if (geofenceCenterPoint.is_simplifi_restricted_geopoint) {
			jQuery('.geofence-disclaimer').css('display', 'block');
		}
		this.geofenceCenterDetails = geofenceCenterPoint;
		this.geofenceCenterDetails.total_android = Math.round(
			(geofenceCenterPoint.android_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		this.geofenceCenterDetails.total_ios = Math.round(
			(geofenceCenterPoint.ios_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		let isRetargetingPoint = false;
		for (const geofenceFeatureObj of geofenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				isRetargetingPoint = geofenceFeatureObj.properties.is_rtg_center == 1;
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}

		if (this.minimap) {
			if (this.minimap.getSource('minimap-data')) {
				if (
					Object.keys(this.detailMapPoints.geometry).length === 0 &&
					this.detailMapPoints.geometry.constructor === Object
				) {
					this.detailMapPoints.geometry = {
						type: 'MultiPoint',
						coordinates: []
					};
				}
				this.minimap.getSource('minimap-data').setData(this.detailMapPoints);
			} else {
				this.minimap.addSource('minimap-data', {
					type: 'geojson',
					data: this.detailMapPoints
				});

				if (this.geofenceBackgroundFillStyle) {
					this.minimap.addLayer({
						id: 'minimap-points-2',
						type: 'circle',
						source: 'minimap-data',
						paint: this.geofenceBackgroundFillStyle
					});
				}

				this.minimap.addLayer({
					id: 'minimap-points',
					type: 'circle',
					source: 'minimap-data',
					paint: this.geofenceFillStyle
				});
			}
			if (isRetargetingPoint && this.minimap.getLayer('minimap-points')) {
				this.minimap.setLayoutProperty('minimap-points', 'visibility', 'none');
				if (this.geofenceBackgroundFillStyle && this.minimap.getLayer('minimap-points-2')) {
					this.minimap.setLayoutProperty('minimap-points-2', 'visibility', 'none');
				}
			} else {
				this.minimap.setLayoutProperty('minimap-points', 'visibility', 'visible');
				if (this.geofenceBackgroundFillStyle) {
					this.minimap.setLayoutProperty('minimap-points-2', 'visibility', 'visible');
				}
			}
			this.setMapBounds(this.minimap, this.detailMapPoints, false);
		}
	}

	/**
	 * Hide geofence center data on hover out
	 */
	protected hideGeofenceCenterDetails() {
		this.detailsTimeInterval = setTimeout(() => {
			this.showGeofenceCenterDetailsFlag = false;
			jQuery('.geofence-details-container').css('display', 'none');
			jQuery('.geofence-disclaimer').css('display', 'none');
		});
	}

	protected refreshMap() {
		const filter = ['in', 'gcd_id'];
		const regions =
			this.selectedCombination && this.selectedCombination.regions ? this.selectedCombination.regions : [];
		this.noRegionData = regions.length > 0 ? false : true;
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map && this.map.getLayer(this.mapType + '_main_' + mapboxMapId + '_' + 'polygons')) {
				Array.prototype.push.apply(filter, regions);
				this.map.setFilter(this.mapType + '_main_' + mapboxMapId + '_' + 'polygons', filter);
				this.map.setFilter(this.mapType + '_active_' + mapboxMapId + '_' + 'points', filter);
			}
		});
		this.onResize({});
	}

	get boundsForAvailableGeoFenceProducts() {
		const features = _.union(
			this.displayGeoFenceData.features,
			this.prerollGeoFenceData.features,
			this.doohGeoRecencyData.features
		);
		const coordinates = this.getCoordinatesFromFeatures(features);
		const mapBounds = this.getBoundsByCoordinates(coordinates);
		return mapBounds;
	}

	protected getCoordinatesFromFeatures(features) {
		let coordinates = [];
		for (const feature of features) {
			coordinates = coordinates.concat(feature.geometry.coordinates);
		}
		return coordinates;
	}

	protected getBoundsByCoordinates(coordinates) {
		const mapBounds = coordinates.reduce(function (bounds, coord) {
			return bounds.extend(coord);
		}, new M.LngLatBounds(coordinates[0], coordinates[0]));
		return mapBounds;
	}

	onResize(event) {
		setTimeout(() => {
			if (this.map) {
				this.map.resize();
			}
		});
	}

	//function to toggle the geography table
	toggleTable() {
		this.showTable = !this.showTable;
		this.tableIcon = this.showTable ? this.dropdownIcons.up : this.dropdownIcons.down;
		if (this.showTable) {
			setTimeout(() => {
				jQuery('.intial-sort-header .sort-btn').addClass('fa fa-long-arrow-down');
				jQuery('.geography-table.geography-r1301 .table').addClass('no-data-message');
			}, 500);
		} else if (!this.showTable) {
			setTimeout(() => {
				jQuery('.geography-table.geography-r1301 .table').removeClass('no-data-message');
			}, 500);
		}
	}

	/**
	 * function to show map layer related to the location selected and zoom into that location
	 * @param $event place
	 */
	onPlaceSelected($event: any) {
		if (this.producttype == 'geofence_only' && this.hasGeoFenceData()) {
			this.showSelectedGeofenceArea($event);
		} else {
			this.showSelectedPolygonLayer($event);
		}
		this.toggleTable();
	}

	/**
	 * function to move map to the center of selected geofence markers
	 * @param places
	 */
	protected showSelectedGeofenceArea(places: any) {
		let geofence: any = _.union(this.displayGeoFenceData.features, this.prerollGeoFenceData.features);
		let features = [];

		if (!geofence) {
			return false;
		}

		//get all selected geofence points
		geofence &&
			places.data.forEach((record: any) => {
				const feature = geofence.filter((data: any) => {
					return (
						record.place.replace(/,/g, '').indexOf(data.properties.name.replace(/,/g, '')) !== -1 ||
						record.place.replace(/,/g, '').indexOf(data.properties.address.replace(/,/g, '')) !== -1
					);
				});
				feature && Array.prototype.push.apply(features, feature);
			});

		if (features.length > 0) {
			const coordinates = this.getCoordinatesFromFeatures(features);
			const mapBounds = this.getBoundsByCoordinates(coordinates);
			const zoomRange = this.get_bounds_zoom(mapBounds);
			this.map.fitBounds(mapBounds, {
				padding: { top: 50, bottom: 50, left: 50, right: 50 },
				linear: true,
				maxZoom: zoomRange
			});
		} else {
			return false;
		}

		this.toggleSelectedRegions([]);
		return true;
	}

	/**
	 * function to show selected location polygon with outline
	 * @param places
	 */
	protected showSelectedPolygonLayer(places: any) {
		let gcd_ids = [];
		let local_ids = [];

		if (!this.selectedCombination.regionData) {
			return false;
		}

		//plucking all the gcd_ids and local_ids for each places
		places.data.forEach((regionData: any) => {
			const [city, region] = regionData.place.split(', ');
			const data = this.selectedCombination.regionData.filter((data: any) => {
				return data.city.indexOf(city) !== -1 && data.region == region;
			});
			if (data) {
				Array.prototype.push.apply(local_ids, _.pluck(data, 'local_id'));
				Array.prototype.push.apply(
					gcd_ids,
					_.pluck(data, 'gcd_id').map((gcd_id) => parseInt(gcd_id))
				);
			}
		});

		//logic for centering the map around the locations selected
		// if there is no local_ids means no location is selected, so
		// go to map's original center point and zoom level
		if (local_ids.length > 0) {
			//showing loading
			this.showLoad = true;
			let filterObj: any = { status: false, localIds: local_ids };
			this.analyticsService.getBoundsByZCTA(filterObj.localIds).subscribe((response: any) => {
				if (!filterObj.status && response.success) {
					this.calculateZoomForFilterObj(filterObj, response.bounds);
					this.map.easeTo({
						center: filterObj.center,
						zoom: filterObj.zoomRange,
						duration: 0
					});
					this.showLoad = false;
				}
			});
		} else {
			return false;
		}

		//logic for showing the location layer and hiding the table
		this.toggleSelectedRegions(gcd_ids);
		return true;
	}

	/**
	 * function to toggle selection layer on map
	 */
	public toggleSelectedRegions(gcd_ids: any[]) {
		//hiding the selection layer if there is no gcd_ids
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (gcd_ids && gcd_ids.length == 0) {
				this.map.setLayoutProperty(this.mapType + '_selection_' + mapboxMapId + '_' + 'polygons', 'visibility', 'none');
				return;
			}
		});

		//showing the selection layer with filtered location gcd_ids
		const filter = ['in', 'gcd_id'];
		this.mapboxMapId.forEach((mapboxMapId) => {
			if (this.map.getLayer(this.mapType + '_selection_' + mapboxMapId + '_' + 'polygons')) {
				Array.prototype.push.apply(filter, gcd_ids);
				this.map.setFilter(this.mapType + '_selection_' + mapboxMapId + '_' + 'polygons', filter);
				this.map.setLayoutProperty(
					this.mapType + '_selection_' + mapboxMapId + '_' + 'polygons',
					'visibility',
					'visible'
				);
			}
		});
	}

	setlegendsChunk(num: number = 4) {
		if (this.mapObj && this.mapObj.legend) {
			this.legendsChunk = _.chunk(this.mapObj.legend, num);
		}
	}
	protected drawDOOHGeoRecencyLayer() {
		this.DoohGeoFenceRecencyLayersDrawn = true;
		this.removeMapLayer('dooh_geofence_points_georecency');
		this.removeMapSource('dooh_geofence_points_georecency');

		if (this.map && !this.map.getLayer('dooh_geofence_points_georecency')) {
			if (this.doohGeoRecencyData.features.length > 0) {
				this.map.addLayer({
					id: 'dooh_geofence_points_georecency',
					type: 'circle',
					source: {
						type: 'geojson',
						data: this.doohGeoRecencyData
					},
					paint: {
						'circle-color': ['get', 'venue_color'],
						'circle-radius': 5,
						'circle-stroke-color': '#FFF',
						'circle-stroke-width': 1
					}
				});

				const popup = new M.Popup({
					closeButton: false,
					closeOnClick: false
				});

				this.map.on('mouseenter', 'dooh_geofence_points_georecency', (e) => {
					this.map.getCanvas().style.cursor = 'pointer';

					// Loop through each feature
					for (let feature of this.doohGeoRecencyData.features) {
						if (feature.geometry.type === 'MultiPoint') {
							const coordinates = feature.geometry.coordinates;

							for (let i = 0; i < coordinates.length; i++) {
								const coordinate = coordinates[i];

								const pixelCoordinate = this.map.project(coordinate);
								const mousePixelPosition = e.point;

								const distance = Math.sqrt(
									Math.pow(pixelCoordinate.x - mousePixelPosition.x, 2) +
										Math.pow(pixelCoordinate.y - mousePixelPosition.y, 2)
								);

								const threshold = 10;
								if (distance <= threshold) {
									const venue_type = e.features[0].properties.venue_type_1;
									const feature_data = this.doohGeoRecencyData.features.filter(
										(f) => f.properties.venue_type_1 === venue_type
									)[0];
									const tooltipData = feature_data.geometry.points_data[i];

									if (tooltipData) {
										const venue_name = tooltipData.venue_name ? tooltipData.venue_name : '';
										const level2 = tooltipData.venue_type_2 ? tooltipData.venue_type_2 : '';
										const impressions = tooltipData.impression
											? Number(tooltipData.impression).toLocaleString('en-US')
											: 'N/A';

										const description = `
											  <div class="dooh-tooltip-content">
												<div class="dooh-tooltip-level1">${venue_name}</div>
												<div class="dooh-tooltip-level2">${venue_type} | ${level2}</div>
												<div class="dooh-tooltip-impressions">Impressions: ${impressions}</div>
											  </div>
											`;
										popup.setLngLat(coordinate).setHTML(description).addTo(this.map);
									}
									break;
								}
							}
						}
					}
				});

				this.map.on('mouseleave', 'dooh_geofence_points_georecency', () => {
					this.map.getCanvas().style.cursor = '';
					popup.remove();
				});
			}
		}
	}
}
